<template>
  <no-ssr>
    <SfCarousel
      v-if="hasSlides"
      class="m-product-carousel"
      :settings="{
        type: 'slider',
        animationDuration: 250,
        rewindDuration: 500,
        rewind: true,
        perView: 4,
        peek: {
          before: 0,
          after: 50,
        },
        slidePerPage: false,
        breakpoints: {
          767: {
            perView: 1,
          },
          991: {
            perView: 2,
          },
          1200: {
            perView: 3,
          },
        }
      }"
    >
      <SfCarouselItem v-if="showAd">
        <div class="card-category card-category-ad">
          <div class="card-category-ad__title">
            Fußleiste & Dämmung inkl.
          </div>
          <div class="card-category-ad__description">
            Entspricht mindestens der bestellten Fläche (m²) des Bodenbelags.
          </div>
          <div class="card-category-ad_icon all-in">
            <img src="/assets/custom/icons/icon-all-in-white.svg" width="auto" height="70px">
            <!--img src="/assets/custom/icons/icon-insulation-large.svg"-->
          </div>
        </div>
      </SfCarouselItem>

      <SfCarouselItem v-for="(category, i) in categoriesCarouselFiltered" :key="i">
        <router-link
          :to="category.url_path"
          class="card-category"
        >
          <div class="card-category__image">
            <SfImage v-if="category.image" :src="getThumbnailPath(category.image)" />
            <!--img v-if="category.id === 4" src="/assets/custom/categories/category-laminat.jpeg">
          <img v-else-if="category.id === 6" src="/assets/custom/categories/category-designboden.jpeg">
          <img v-else-if="category.id === 5" src="/assets/custom/categories/category-vinylboden.jpeg">
          <img v-else-if="category.id === 8" src="/assets/custom/categories/category-parkett.jpeg">
          <img v-else-if="category.id === 69" src="/assets/custom/categories/category-wand-bodenfliese.jpeg">
          <img v-else-if="category.id === 9" src="/assets/custom/categories/category-abschlussleisten.jpeg">
          <img v-else-if="category.id === 122" src="/assets/custom/categories/category-aluminiumprofile.jpeg">
          <img v-else-if="category.id === 30" src="/assets/custom/categories/category-daemmung-verlegung.jpeg">
            <img v-else-if="category.id === 29" src="/assets/custom/categories/category-leistenzubehoer.jpeg">
            <img v-else-if="category.id === 127" src="/assets/custom/categories/category-parkettzubehoer.jpeg">-->
          </div>
          <div class="card-category__name">
            {{ category.name }}
          </div>
        </router-link>
      </SfCarouselItem>
    </SfCarousel>
  </no-ssr>
</template>

<script>
import { mapGetters } from 'vuex';
import { SfCarousel, SfImage } from '@storefront-ui/vue';
import NoSSR from 'vue-no-ssr';
import { getThumbnailPath } from '@vue-storefront/core/helpers'

export default {
  name: 'MCategoryCarousel',
  components: {
    'no-ssr': NoSSR,
    SfCarousel,
    SfImage
  },
  props: {
    categoriesIds: {
      type: Array,
      default: () => []
    },
    showAd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getCategories: 'category/getCategories'
    }),
    categoriesCarouselFiltered () {
      let categories = this.getCategories;

      if (this.categoriesIds.length > 0) {
        categories = categories.filter((item) => {
          return (this.categoriesIds.includes(item.id))
        })
      } else {
        categories = categories.filter((item) => {
          return (item.parent_id === 10 && item.product_count > 0)
        })
      }

      // console.log(categories);

      return categories;
    },
    hasSlides () {
      return this.showAd || this.categoriesCarouselFiltered.length > 0
    }
  },
  methods: {
    getThumbnailPath (image) {
      return getThumbnailPath(image, 800, 800, 'category');
    }
  }
};
</script>
